import { ServiceData } from '..';
/**
 * 서버로 보내야 하는 데이터들의 공통 분모와 공통 로직을 추가 한다.
 */
// eslint-disable-next-line import/prefer-default-export
export class AbsDistributorNotice extends ServiceData {
    reqBody;
    constructor(form) {
        super();
        this.reqBody = form;
    }
}
